// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
export const COMMENT_FIELDS = {
  entityId: 'entityId',
  body: 'body',
  createdDate: 'createdDate',
  roles: 'roles',
  userFullName: 'userFullName',
};